"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAiConfigTypeInventory = buildAiConfigTypeInventory;
const catalog_1 = require("./catalog");
function buildAiConfigTypeInventory(types) {
    const counts = new Map();
    for (const type of types) {
        counts.set(type, (counts.get(type) ?? 0) + 1);
    }
    const entries = [...counts.entries()]
        .map(([type, count]) => {
        if ((0, catalog_1.isAiConfigType)(type)) {
            return { type, count, status: 'canonical', canonicalType: type };
        }
        const canonicalType = (0, catalog_1.suggestCanonicalAiConfigType)(type);
        return canonicalType
            ? { type, count, status: 'case-variant', canonicalType }
            : { type, count, status: 'unknown' };
    })
        .sort((left, right) => left.type.localeCompare(right.type));
    const typesByLowerCase = new Map();
    for (const entry of entries) {
        const normalizedType = entry.type.toLowerCase();
        const variants = typesByLowerCase.get(normalizedType) ?? [];
        variants.push(entry);
        typesByLowerCase.set(normalizedType, variants);
    }
    const caseCollisions = [...typesByLowerCase.entries()]
        .filter(([, variants]) => variants.length > 1)
        .map(([normalizedType, variants]) => ({
        normalizedType,
        types: variants.map(({ type }) => type),
        count: variants.reduce((total, { count }) => total + count, 0),
    }))
        .sort((left, right) => left.normalizedType.localeCompare(right.normalizedType));
    const canonicalCount = entries
        .filter(({ status }) => status === 'canonical')
        .reduce((total, { count }) => total + count, 0);
    return {
        totalCount: types.length,
        distinctCount: entries.length,
        canonicalCount,
        nonCanonicalCount: types.length - canonicalCount,
        entries,
        caseCollisions,
    };
}
